import axios from "axios";

const BASE_ROUTE = "cat-surgery-providers";

export const searchSurgeryProviders = (q, territorio) => {
    const params = { q };
    if (territorio && String(territorio).trim() !== "") {
        params.territorio = territorio;
    }
    return axios.get(`${BASE_ROUTE}/search`, { params });
};
